module.exports = __webpack_public_path__ + "img/spark.03b505ee.png";